import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { api, clearToken } from '../lib/api.js'

export function Layout() {
  const navigate = useNavigate()
  const [me, setMe] = useState(null)

  useEffect(() => {
    api('/auth/me')
      .then((r) => setMe(r.user))
      .catch(() => {})
  }, [])

  function logout() {
    clearToken()
    navigate('/login', { replace: true })
  }

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">GrowingChild</div>
        <nav>
          <NavLink to="/" end>
            Panel
          </NavLink>
          <NavLink to="/users">Kullanicilar</NavLink>
          <NavLink to="/children">Cocuklar</NavLink>
        </nav>
        <div className="sidebar-footer">
          {me && (
            <div className="me">
              <div className="me-name">{me.full_name}</div>
              <div className="me-role">{me.role}</div>
            </div>
          )}
          <button className="btn-ghost" onClick={logout}>
            Cikis
          </button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  )
}
